import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// import { createActaPaso2 } from "../../../api/acta";
// import { useFormActaStore } from "../../../store/formActaStore";
import "./style.css";

import "leaflet/dist/leaflet.css";
// import MapaActa2 from "../../Mapas/MapaActa2";
// import InputRHF from "../../../components/InputRHF";

// import { terceraEtapa } from "../../../services/actas.service";
// import { terceraEtapaHandler } from "../../../handlers/actas.handler";

import Loading from "../Loading";
import useWindowSize from "../../hooks/useWindowSize";
import InputFileRHF from "../InputRHF/InputFileRHF";
import { useFormActaStore } from "../../store/formActaStore";
import { useGeneralAppStore } from "../../store/generalAppStore";

const SubirFotosCustom = ({ watch, errors, setValue, control, campo, multiple }) => {
  const size = useWindowSize();
  const { loading, setLoading, setUltimoPaso, acta_id, defaultValues } = useFormActaStore();
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [previews, setPreviews] = useState([]);
  const { width } = size;

  const { loads } = useGeneralAppStore();

  const [zoomStyle, setZoomStyle] = useState({});

  const handleMouseMove = (e) => {
    const { offsetX, offsetY, target } = e.nativeEvent;
    const { width, height } = target;

    const xPos = (offsetX / width) * 100;
    const yPos = (offsetY / height) * 100;

    setZoomStyle({
      transform: `scale(1.5)`,
      transformOrigin: `${xPos}% ${yPos}%`,
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({
      transform: "scale(1)",
    });
  };

  useEffect(() => {
    if (previews.length > 0) {
      setImagePreviewUrl(previews[0]);
    }
  }, [previews]);
  return (
    <>
      {/* {loading ? (
                <Loading />
            ) : ( */}
      <motion.div
        key="form"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="w-100"
      >
        <div className="d-flex flex-wrap gap-4 w-100  justify-content-center  position-relative ">
          {loads.includes("tercera_etapa") && (
            <div
              className="w-100 h-100 d-flex justify-content-center align-items-center position-absolute"
              style={{ zIndex: "9", backgroundColor: "rgba(255,255,255,0.8)" }}
            >
              <Loading sizeIcono="50px" sizeLoad="70px" font="16px" />
            </div>
          )}
          <section
            className={`d-flex  gap-3 justify-content-center ${
              width <= 640 ? "flex-column align-items-center w-100" : ""
            }  `}
            style={{ height: width < 640 ? "550px" : "500px" }}
          >
            {multiple && (
              <div
                className={` border border-2 rounded d-flex ${
                  width <= 360 ? " overflow-x-scroll" : "flex-column  overflow-y-scroll"
                }    gap-3 justify-content-start p-2`}
                style={{
                  width: width <= 360 ? "100%" : "75px",
                  aspectRatio: width <= 360 ? "" : "3/4",
                }}
              >
                {previews?.map((imagen, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        aspectRatio: width <= 340 ? "3/4" : "9/16",

                        border:
                          imagePreviewUrl?.url == imagen.url
                            ? "2px solid #1134C9"
                            : "2px solid #c9c9c9",
                        cursor: "pointer",
                        overflow: "hidden",
                        // flex: "1 1 calc(33.333% - 20px)",
                        minHeight: "55px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      className=" d-flex flex-column justify-content-center align-items-center"
                      onClick={() => {
                        setImagePreviewUrl(imagen);
                      }}
                    >
                      <img
                        src={imagen.url}
                        alt={imagen.name}
                        style={{
                          // objectFit: "contain"
                          objectFit: "contain",
                          width: "100%",
                          height: "100%",
                          backgroundColor: "#c9c9c9",
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            )}

            <div
              className={` position-relative ${width >= 640 ? "col" : "w-100"}`}
              style={{ aspectRatio: "3/4" }}
            >
              {(errors?.[campo] ||
                watch(campo)?.some(
                  (file) => !["image/png", "image/jpeg", "image/jpg"].includes(file.type)
                )) && (
                <div
                  className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                  style={{ zIndex: "999" }}
                >
                  <p className=" text-danger border border-2 border-danger bg-white p-2 rounded  fw-medium">
                    {errors?.[campo]?.message || "Solo se permiten archivos .jpeg, .jpg, .png"}
                  </p>
                </div>
              )}
              <div className=" border border-2 zoom-container" style={{ backgroundColor: "#999" }}>
                <>
                  {imagePreviewUrl ? (
                    <img
                      src={imagePreviewUrl.url}
                      alt={imagePreviewUrl.name}
                      style={{
                        ...zoomStyle,
                        width: "100%",
                        maxWidth: "400px",
                        objectFit: "contain",
                        aspectRatio: "3/4",
                      }}
                      className="zoom-image"
                      onMouseMove={handleMouseMove}
                      onMouseLeave={handleMouseLeave}
                    />
                  ) : (
                    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                      {multiple ? (
                        <span className="fw-bold text-white">No tiene imágenes cargadas</span>
                      ) : (
                        <span className="fw-bold text-white">No tiene imágen cargada</span>
                      )}
                    </div>
                  )}
                </>
              </div>
            </div>
          </section>
          <section>
            <div className={`d-flex h-100  flex-column gap-3 ${width < 995 ? "" : ""} `}>
              {multiple && (
                <Alert variant="success">Puede subir varias imagenes seleccionandolas</Alert>
              )}
              <InputFileRHF
                proyect={"arbolado"}
                multiple={multiple}
                campo={campo}
                setValue={setValue}
                setPreviews={setPreviews}
                accept="image/png, image/jpeg, image/jpg, application/pdf"
              />
              {/* <button
                                disabled={
                                    !watch(campo) ||
                                    watch(campo).length == 0 ||
                                    watch(campo)?.some(
                                        (file) => !["image/png", "image/jpeg", "image/jpg"].includes(file.type)
                                    )
                                }
                                className="col-2 btn btn-success btn-sm w-100"
                                type="submit"
                            >
                                Siguiente
                            </button> */}
              {(watch(campo)?.length == 0 || watch(campo)?.length > 5) && (
                <>
                  {errors?.[campo]?.message && (
                    <Alert variant="danger" className="text-center">
                      {errors?.[campo].message}
                    </Alert>
                  )}
                </>
              )}
            </div>
          </section>
        </div>
      </motion.div>
      {/* )} */}
    </>
  );
};
export default SubirFotosCustom;
